/**
 * « Actualités non lues » : mémoire locale de la dernière ouverture du fil.
 *
 * Volontairement par APPAREIL (localStorage) et non par compte : le fil se lit
 * sans être connecté, et c'est la même logique que le ❤️ anonyme des
 * publications. Aucun aller-retour serveur, donc le compteur s'éteint
 * instantanément à l'ouverture.
 */

const CLE = 'shop_feed_seen_at';
/** Signal interne : le badge se met à jour sans recharger la page. */
export const EVENEMENT_VU = 'folies:publications-seen';

/** Première visite : on considère comme neuf ce qui date de moins d'une semaine. */
const FENETRE_PREMIERE_VISITE_JOURS = 7;

export function derniereOuvertureDuFil(): Date {
  try {
    const brut = localStorage.getItem(CLE);
    if (brut) {
      const date = new Date(brut);
      if (!isNaN(date.getTime())) return date;
    }
  } catch {
    // Navigation privée ou stockage refusé : on retombe sur la fenêtre par défaut.
  }
  return new Date(Date.now() - FENETRE_PREMIERE_VISITE_JOURS * 24 * 60 * 60 * 1000);
}

/** Le fil vient d'être ouvert : le compteur retombe à zéro. */
export function marquerFilCommeVu(): void {
  try {
    localStorage.setItem(CLE, new Date().toISOString());
  } catch {
    // Sans stockage, le compteur se recalculera à chaque visite — sans gravité.
  }
  window.dispatchEvent(new Event(EVENEMENT_VU));
}
